import { ListChecks, Shield } from 'lucide-react';
import { ThemeToggle } from './theme-toggle';
import { Navigation } from './Navigation';
import { useAuth } from '../lib/auth';
import { Button } from './ui/button';
import { cn } from '@/lib/utils';

interface HeaderProps {
  currentPage: string;
  onPageChange: (page: string) => void;
}

export function Header({ currentPage, onPageChange }: HeaderProps) {
  const { signOut, user } = useAuth();
  
  console.log('Current user:', user);

  return (
    <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <ListChecks className="w-6 h-6 text-blue-600" />
          <h1 className="text-xl font-bold">RAIL</h1>
        </div>
        <div className="flex items-center space-x-4">
          <nav className="flex items-center gap-4">
            <Navigation currentPage={currentPage} onPageChange={onPageChange} />
            {(user?.user_metadata?.role === 'admin' || user?.email === 'hsanchez@driveformvt.com') && (
              <Button
                variant={currentPage === 'admin' ? 'default' : 'ghost'}
                className={cn(
                  'gap-2',
                  currentPage === 'admin'
                    ? 'bg-gray-800 text-gray-100 hover:bg-gray-700'
                    : 'text-gray-300 hover:text-gray-100 hover:bg-gray-800'
                )}
                onClick={() => onPageChange('admin')}
              >
                <Shield className="w-4 h-4" />
                Admin
              </Button>
            )}
          </nav>
          <ThemeToggle />
          <button
            onClick={() => signOut()}
            className="text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100"
          >
            Sign Out
          </button>
        </div>
      </div>
    </header>
  );
}